@if (objSkeeper) {
  <sd-component-wrapper
    id="ProductReviewsComponent_{{pageTemplate.charAt(0).toUpperCase() + pageTemplate.slice(1).toLowerCase()}}Page_1"
    [content]="wrapperContent"
    [themesConfig]="themesConfig"
    [brand]="brand"
    [marginSize]="MarginEnum.without_margin"
    [componentWidth]="ComponentWrapperWidthEnum.absoluteFullWidth"
    >
    <ng-container sd-component-wrapper-component>
      <div
        class="skeepers_product__reviews"
        [attr.data-product-id]="objSkeeper.productId"
        [attr.data-locale]="objSkeeper.locale"
        [attr.data-price]="objSkeeper.price"
        [attr.data-currency]="objSkeeper.currency"
        [attr.data-name]="objSkeeper.name"
        [attr.data-url]="objSkeeper.url"
        [attr.data-image-url]="objSkeeper.imageUrl"
      ></div>
    </ng-container>
  </sd-component-wrapper>
}
